import { Switch } from 'antd';
import { useEffect, useState } from 'react';

type CustomSwitchProps = {
    checked: string;
    unchecked: string;
    reverse?: boolean;
    value?: number;
    onChange?: (value: number) => void;
};

export function CustomSwitch(props: CustomSwitchProps) {
    const { checked, unchecked, onChange, reverse = false, value } = props;

    const [currrentValue, setCurrentValue] = useState(value);

    const funcReverse = (e: boolean): 0 | 1 => {
        if (reverse) {
            return e ? 0 : 1;
        }
        return e ? 1 : 0;
    };

    const handleChange = (e: boolean): void => {
        const newValue = funcReverse(e);
        setCurrentValue(newValue);
        if (typeof onChange === 'function') {
            onChange(newValue);
        }
    };

    useEffect(() => {
        setCurrentValue(value);
    }, [value]);

    return (
        <Switch
            checked={reverse ? currrentValue === 0 : currrentValue === 1}
            checkedChildren={checked}
            onChange={handleChange}
            unCheckedChildren={unchecked}
        />
    );
}
